// src/components/AddMemberDialog.jsx

import React, { useState } from "react";
import {
    Box,
    Button,
    Dialog,
    IconButton,
    MenuItem,
    Paper,
    Select,
    Stack,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CopyLinkIcon from "./CopyLinkIcon";

const AddMemberDialog = ({ 
    open, 
    onClose, 
    onInvite, 
    inviteEmail,
    setInviteEmail,
    inviteRole,
    setInviteRole,
    onCopyInvitationLink
}) => {
    const theme = useTheme();

    const handleRoleChange = (event) => {
        setInviteRole(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        onInvite(event);
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth={false}
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    width: '616px',
                    height: '343px',
                    maxWidth: 'none',
                    maxHeight: 'none',
                    boxShadow: theme.customShadows.cardElevated,
                }
            }}
        >
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: "absolute",
                    top: "31px",
                    right: "31px",
                    zIndex: 1,
                }}
            >
                <CloseIcon />
            </IconButton>

            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    width: "100%",
                    height: "100%",
                    padding: "45px 50px",
                }}
            >
                <Stack
                    direction="column"
                    spacing={2.5}
                    sx={{
                        width: "100%",
                        height: "100%",
                    }}
                >
                    <Stack spacing={2.1} width="100%">
                        <Typography
                            variant="h5"
                            color="primary.main"
                        >
                            Add New Member
                        </Typography>

                        <Stack spacing={3.9} width="100%">
                            <Stack spacing={2} width="100%">
                                <Typography
                                    variant="body1"
                                    color="text.secondary"
                                >
                                    Enter the email address of the new member.
                                </Typography>

                                <Stack
                                    direction="row"
                                    spacing={2}
                                    alignItems="center"
                                    width="100%"
                                >
                                    <TextField
                                        placeholder="Email"
                                        variant="outlined"
                                        value={inviteEmail}
                                        onChange={(e) => setInviteEmail(e.target.value)}
                                        required
                                        sx={{
                                            flex: 1,
                                            height: "60px",
                                            "& .MuiOutlinedInput-root": {
                                                height: "60px",
                                                borderColor: "divider",
                                            },
                                            "& .MuiInputBase-input::placeholder": {
                                                color: "text.secondary",
                                                fontSize: "16px",
                                                opacity: 1,
                                            },
                                        }}
                                    />

                                    <Select
                                        value={inviteRole}
                                        onChange={handleRoleChange}
                                        displayEmpty
                                        sx={{
                                            minWidth: "120px",
                                            width: "120px",
                                            height: "60px",
                                            fontSize: "16px",
                                            color: "text.primary",
                                            "& .MuiSelect-select": {
                                                paddingY: "18px",
                                                paddingX: "14px",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                height: "60px",
                                            },
                                        }}
                                    >
                                        <MenuItem value="admin">Admin</MenuItem>
                                        <MenuItem value="user">User</MenuItem>
                                    </Select>
                                </Stack>
                            </Stack>

                            <Stack direction="row" spacing={2.9} width="100%">
                                <Button
                                    variant="outlined"
                                    onClick={onCopyInvitationLink}
                                    startIcon={
                                        <CopyLinkIcon sx={{ width: "21px", height: "11px" }} />
                                    }
                                    sx={{
                                        width: "245px",
                                        height: "63px",
                                        borderColor: "primary.main",
                                        color: "primary.main",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        boxShadow: "none",
                                        "&:hover": {
                                            borderColor: "primary.dark",
                                            color: "primary.dark",
                                            boxShadow: "none",
                                        }
                                    }}
                                >
                                    Copy Invitation Link
                                </Button>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        width: "248px",
                                        height: "63px",
                                        backgroundColor: "primary.main",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        boxShadow: theme.customShadows.primaryButton,
                                        "&:hover": {
                                            backgroundColor: "primary.dark",
                                            boxShadow: theme.customShadows.primaryButtonHover,
                                        }
                                    }}
                                >
                                    Done
                                </Button>
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </Box>
        </Dialog>
    );
};

export default AddMemberDialog;